const DEFAULT_CURRENCY = 'INR';

export function formatCurrency(value, currency = DEFAULT_CURRENCY) {
  const n = typeof value === 'string' ? Number(value) : value;
  if (n == null || Number.isNaN(n)) return '—';
  const locale = currency === 'INR' ? 'en-IN' : 'en-US';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${currency} ${n.toFixed(2)}`;
  }
}

export function getCurrencySymbol(currency = DEFAULT_CURRENCY) {
  const locale = currency === 'INR' ? 'en-IN' : 'en-US';
  try {
    const parts = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).formatToParts(0);
    const part = parts.find((p) => p.type === 'currency');
    return part ? part.value : currency;
  } catch {
    return currency;
  }
}

export function formatNumber(value, fractionDigits = 0) {
  const n = typeof value === 'string' ? Number(value) : value;
  if (n == null || Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n);
}

export function formatPercent(value, fractionDigits = 1) {
  const n = typeof value === 'string' ? Number(value) : value;
  if (n == null || Number.isNaN(n)) return '—';
  return `${n.toFixed(fractionDigits)}%`;
}
